let initialState = {
  raw_data: [],
  week: 4,
  parsed_data: [],
  days: 30,
  overrideReportsData: undefined,
  view: 'overrides', // 'updates'
};

const reportReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'REPORTS_DATA': {
      return Object.assign({}, state, { raw_data: action.payload });
    }
    case 'OVERRIDE_REPORTS_DATA': {
      return Object.assign({}, state, { overrideReportsData: action.payload });
    }
    case 'UPDATE_DAYS': {
      return Object.assign({}, state, { days: action.payload });
    }
    case 'UPDATE_VIEW': {
      return Object.assign({}, state, { view: action.payload });
    }
    case 'LOGOUT': {
      return initialState;
    }
    default:
      return state;
  }
};
export default reportReducer;
